import React from 'react';
import type { ContractStatisticsResponse } from '../services/rtkApi';
import { Block, Typography } from '@klp/design';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { KlpPalette } from '@klp/design/Theme/KlpPalette';
import { KlpFontVariant } from '@klp/design/Theme/KlpFontVariant';
type ContractToRegistrationSummaryStatisticsProps = {
    statistics?: ContractStatisticsResponse;
    isOkonomi?: boolean;
};

const useStyles = makeStyles(() => ({
    greenText: {
        color: KlpPalette.secondary.main,
    },
    text: {
        paddingTop: '5px',
        paddingLeft: '2px',
        fontSize: KlpFontVariant.small.fontSize,
    },
}));
export const ContractToRegistrationSummaryStatistics: React.FC<
    ContractToRegistrationSummaryStatisticsProps
> = ({ statistics, isOkonomi }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <>
            <Block marginBottom="bulky">
                {!isOkonomi && (
                    <Typography
                        klpTypographyVariant="epsilon"
                        data-cy="ContractsExpiringSummary__MarkedValue"
                    >
                        <span className={classes.greenText}>
                            {statistics?.Ny ?? 0}{' '}
                        </span>
                        &nbsp;
                        <span className={classes.text}>
                            {t('contractRegistration.newProcess')}
                        </span>
                    </Typography>
                )}
                <Typography
                    klpTypographyVariant="epsilon"
                    data-cy="ContractsExpiringSummary__MarkedValue"
                >
                    <span className={classes.greenText}>
                        {statistics?.PagaaendeForvalter ?? 0}{' '}
                    </span>
                    &nbsp;
                    <span className={classes.text}>
                        {t('contractRegistration.ongoingProcessForvalter')}
                    </span>
                </Typography>
                <Typography
                    klpTypographyVariant="epsilon"
                    data-cy="ContractsExpiringSummary__MarkedValue"
                >
                    <span className={classes.greenText}>
                        {statistics?.PagaaendeOekonomi ?? 0}{' '}
                    </span>
                    &nbsp;
                    <span className={classes.text}>
                        {t('contractRegistration.ongoingProcessFinance')}
                    </span>
                </Typography>
            </Block>
        </>
    );
};
